module.exports = __webpack_public_path__ + "img/reject.9e4d8226.svg";